import { EventEmitter } from "events";
//import { R3Logger } from "../logs/logger";

/**
 * A tipagem do customEvents deve ser a união dos tipos. \
 * No construtor deve ser passado o array com os tipos
 */
export class R3EventEmitter<customEvent extends string | symbol = '', content = {}> extends EventEmitter {
	private readonly _createLogs: boolean = false;
	private readonly _filePath: string = '';
	private readonly _fileName: string = '';
	//private readonly _logger: R3Logger | null = null;

	private readonly _events: customEvent[] = [];

	constructor(events: customEvent[], params?: { createLogs: boolean, writeLog: boolean, filePath?: string, fileName?: string }) {//{ createLogs: true, writeLog: true, filePath: string, fileName: string } | { createLogs: true, writeLog: false } | { createLogs: false }) {
		super();
		this._events = events;
		if (params) {
			this._createLogs = params.createLogs;
			//this._logger = new R3Logger({ writeLogs: params.writeLog, filePath: params.filePath, logFileName: params.fileName });
		}
	}

	/**
	 * @inheritdoc
	 * ---
	 * 
	 * Recebe os argumentos para o listener dentro de um array
	 */
	on<T = content>(eventName: customEvent, listener: (args: T) => void): this {


		// if (this._createLogs) {
		const currentDate = new Date();

		const hourLog = `${currentDate.getFullYear()}/${currentDate.getMonth()}/${currentDate.getDate()} - ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`
		/*if (this._logger) {
			this._logger.log(`${hourLog} Evento ${eventName.toString()} foi escutado`);
		}*/
		// }



		return super.on(eventName as (string | symbol), listener as () => void);
	}

	/**
	 * @inheritdoc
	 * ---
	 * 
	 * Emite um evento enviando argumentos para os listeners
	 */
	emit<T = content>(eventName: customEvent, args?: Partial<T>): boolean {
		if (!(this._events.includes(eventName))) {
			throw new Error('Evento não registrado na lista de eventos disponíveis para este emitter')
		}

		if (this._createLogs) {
			const currentDate = new Date();

			const hourLog = `${currentDate.getFullYear()}/${currentDate.getMonth()}/${currentDate.getDate()} - ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`

			/*if (this._logger) {
				this._logger.log(`${hourLog} Evento ${eventName.toString()} foi emitido`);

			}*/

		}
		return super.emit(eventName as (string | symbol), args);

	}

}

